<template>
  <div class="totop" @click="totop()" v-if="show">
    <i class="van-icon iconfont icon-totop"></i>
  </div>
</template>

<script>
  export default {
    name: "totop",
    data () {
      return {
        show:false,
        fullHeight: document.documentElement.clientHeight,
      }
    },
    methods:{
      totop:function () {
        $('body,html').animate({scrollTop: 0},500);
      },
      //      监听滚动的距离
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if(scrollTop>this.fullHeight){
          this.show =true
        }
        if(scrollTop==0){
          this.show =false
        }
      },
//      scrollplay:function () {
//        var ht = $(window).height()
//        if( document.documentElement.scrollTop > ht){
//          this.show = true
//        }else{
//          this.show = false
//        }
//      }
    },
    mounted() {
//      window.addEventListener('scroll', this.scrollplay)
      window.addEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="less" scoped>
  .totop{
    display: inline-block;
    position: fixed;
    right: 8px;
    bottom: 60px;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 50%;
    padding: 0px;
    .iconfont{
      font-size: 40px;
      margin: 0px;
      color: #ddd;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/totop.vue